import { TextInput } from 'components/common/input'
import { UseFormSetValue, FieldValues, FieldErrors } from 'react-hook-form'
import { useEffect, useRef, useState } from 'react'

type Props = {
  setValue: UseFormSetValue<FieldValues>
  errors: FieldErrors<FieldValues>
  reasons?: string[]
  defaultMap?: Record<string, string>
}

const RmaReasonMapping = ({
  reasons = [],
  defaultMap = {},
  setValue,
  errors,
}: Props) => {
  const [mapping, setMapping] = useState<Record<string, string>>({})
  const containerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const initialMap: Record<string, string> = {}

    reasons.forEach((condition) => {
      initialMap[condition] = defaultMap?.[condition] || ''
    })

    setMapping(initialMap)

    setValue('rmaReasonCodeMap', initialMap)
  }, [reasons])

  const handleChange = (condition: string, value: string) => {
    const updated = {
      ...mapping,
      [condition]: value,
    }

    setMapping(updated)

    setValue('rmaReasonCodeMap', updated, { shouldValidate: true })
  }

  useEffect(() => {
    if (errors?.rmaReasonCodeMap) {
      containerRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    }
  }, [errors?.rmaReasonCodeMap])

  if (reasons.length === 0) return null

  const rootError = (errors?.rmaReasonCodeMap as any)?.message

  return (
    <div className="mt-6">
      <h4 className="mb-2 text-sm font-medium text-gray-700">
        SAP Reason Mapping
      </h4>

      <div
        ref={containerRef}
        className="flex flex-col divide-y rounded-md border"
      >
        {reasons.map((reason) => (
          <div
            key={reason}
            className="flex items-center justify-between gap-4 px-3 py-2"
          >
            <p className="min-w-[150px] text-sm text-gray-700">{reason}</p>

            <TextInput
              placeholder="Enter SAP Code"
              value={mapping[reason] || ''}
              onChange={(e) => handleChange(reason, e.target.value)}
              className="w-[150px]"
            />
          </div>
        ))}
      </div>
      {/* Root Error */}
      {rootError && <p className="mt-2 text-xs text-red-600">{rootError}</p>}
    </div>
  )
}

export default RmaReasonMapping
